import { callExternalApi } from "./external-api.service";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

export const getPublicResource = async () => {
  const config = {
    url: `${apiServerUrl}/api/study/active/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getOnboardingStatus = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/onboarding/status/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getOnboardingForm = async (token, stepKey) => {
  const config = {
    url: `${apiServerUrl}/api/onboarding/forms/${encodeURIComponent(stepKey)}/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const submitOnboardingForm = async (token, stepKey, values, options = {}) => {
  const payload = options.skip
    ? { skip: true }
    : { values };
  const config = {
    url: `${apiServerUrl}/api/onboarding/forms/${encodeURIComponent(stepKey)}/submit/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

/** Dashboard recap for Updates answers (not Preferences). */
export const getOnboardingFormSummary = async (token, stepKey) => {
  const config = {
    url: `${apiServerUrl}/api/onboarding/forms/${encodeURIComponent(stepKey)}/summary/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};


export const getAdminResource = async () => {
  const config = {
    url: `${apiServerUrl}/api/messages/admin/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getPreScreenNextQuestion = async (token, answerId) => {
  const params = new URLSearchParams();
  if (answerId) {
    params.append('answer_id', answerId);
  }
  const config = {
    url: `${apiServerUrl}/api/pre-screen/next-question/?${params.toString()}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getPreScreenPreviousQuestion = async (token, currentAnswerId) => {
  const config = {
    url: `${apiServerUrl}/api/pre-screen/previous-question/?current_answer_id=${currentAnswerId}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getPreScreenCurrentAnswer = async (token, questionId) => {
  const config = {
    url: `${apiServerUrl}/api/pre-screen/current-answer/?question_id=${questionId}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const submitPreScreenAnswer = async (token, questionId, answerValue, answerId = null) => {
  const config = {
    url: `${apiServerUrl}/api/pre-screen/submit/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify({ 
      question_id: questionId, 
      answer_value: answerValue,
      answer_id: answerId 
    }),
  };  

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

// =============================================================================
// Anonymous Pre-Screen API Functions (no authentication required)
// =============================================================================

export const getPreScreenNextQuestionAnonymous = async (sessionKey, answerId = null, questionGroup = null) => {
  const params = new URLSearchParams({
    session_key: sessionKey,
    question_group: questionGroup
  });
  if (answerId) {
    params.append('answer_id', answerId);
  }
  
  const config = {
    url: `${apiServerUrl}/api/pre-screen/anonymous/next-question/?${params.toString()}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const submitPreScreenAnswerAnonymous = async (sessionKey, questionId, answerValue, questionGroup = null, ftAttribution = null) => {
  const body = {
    session_key: sessionKey,
    question_id: questionId, 
    answer_value: answerValue,
    question_group: questionGroup
  };
  if (ftAttribution) {
    body.ft_attribution = ftAttribution;
  }
  const config = {
    url: `${apiServerUrl}/api/pre-screen/anonymous/submit/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    data: JSON.stringify(body),
  };  

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getPreScreenCurrentAnswerAnonymous = async (sessionKey, questionId) => {
  const config = {
    url: `${apiServerUrl}/api/pre-screen/anonymous/current-answer/?session_key=${sessionKey}&question_id=${questionId}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getPreScreenPreviousQuestionAnonymous = async (sessionKey, currentAnswerId) => {
  const params = new URLSearchParams({ 
    session_key: sessionKey,
    current_answer_id: currentAnswerId 
  });
  
  const config = {
    url: `${apiServerUrl}/api/pre-screen/anonymous/previous-question/?${params.toString()}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const transferSessionAnswers = async (token, sessionKey, questionGroup = null) => {
  const requestBody = { session_key: sessionKey };
  
  // Include question_group if provided
  if (questionGroup) {
    requestBody.question_group = questionGroup;
  }
  
  const config = {
    url: `${apiServerUrl}/api/pre-screen/transfer/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify(requestBody),
  };  

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getQuestionGroupBySlug = async (slug) => {
  const config = {
    url: `${apiServerUrl}/api/pre-screen/question-group/${slug}/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getDefaultQuestionGroup = async () => {
  const config = {
    url: `${apiServerUrl}/api/pre-screen/question-group/default/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getEmbeddedSigningUrls = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/consent/signing-urls/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};



export const getConsentStatus = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/consent/status/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getAwaitCountersignStatus = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/onboarding/await-countersign/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const getCountersignStatus = async (countersignToken) => {
  const config = {
    url: `${apiServerUrl}/api/consent/countersign/${encodeURIComponent(countersignToken)}/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const openCountersignSession = async (countersignToken) => {
  const config = {
    url: `${apiServerUrl}/api/consent/countersign/${encodeURIComponent(countersignToken)}/open/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const listPhlebProviderCollections = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/phleb/collections/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const updatePhlebProviderKitId = async (token, collectionId, kitId, reason = null) => {
  const config = {
    url: `${apiServerUrl}/api/phleb/collections/${collectionId}/kit-id/`,
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: { kit_id: kitId, reason },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const updatePhlebProviderCollectionStatus = async (token, collectionId, action, extra = {}) => {
  const config = {
    url: `${apiServerUrl}/api/phleb/collections/${collectionId}/status/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: { action, ...extra },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const downloadConsentDocument = async (token, documentId) => {
  const config = {
    url: `${apiServerUrl}/api/consent/download/${documentId}/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob'
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const createPersonaReference = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/verification/new-inquiry/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const updateInquiryId = async (token, referenceId, inquiryId) => {
  const config = {
    url: `${apiServerUrl}/api/verification/update-inquiry-id/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify({ reference_id: referenceId, inquiry_id: inquiryId }),
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const confirmVerification = async (token, referenceId, inquiryId) => {
  const config = {
    url: `${apiServerUrl}/api/verification/confirm/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify({ reference_id: referenceId, inquiry_id: inquiryId }),
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

// NEW: Disaggregated profile endpoints
export const getBasicUserInfo = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/me/basic/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const getContactData = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/me/contact/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const getVerificationData = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/me/verification/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const getMedicalStatus = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/me/medical-status/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const updateUserName = async (token, data) => {
  const config = {
    url: `${apiServerUrl}/api/me/name/`,
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify(data),
  };

  const { data: responseData, error } = await callExternalApi({ config });
  return { data: responseData || null, error };
};

// DEPRECATED: Use getVerificationData instead
export const getVerificationProfile = async (token) => {
  return getVerificationData(token);
};

export const getPreScreenSummary = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/pre-screen/summary/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const updateContactData = async (token, data) => {
  const config = {
    url: `${apiServerUrl}/api/me/contact/add/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify(data),
  };

  const { data: responseData, error } = await callExternalApi({ config });
  return { data: responseData || null, error };
};

export const removeContactData = async (token, type, id) => {
  const config = {
    url: `${apiServerUrl}/api/me/contact/remove/`,
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify({ type, id }),
  };

  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

// Keep old names for compatibility with existing code
export const updateUserProfile = updateContactData;
export const removeUserProfileData = removeContactData;
export const getUserProfile = getContactData;

export const downloadCareRecommendations = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/records/care_recommendations/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob'
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const listPendingSampleCollections = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/sample-collections/pending/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getUserSampleCollections = async (accessToken) => {
  const config = {
    url: `${apiServerUrl}/api/sample-collections/pending/`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};

export const submitSampleCollection = async (accessToken, sampleCollectionId, formData) => {
  const config = {
    url: `${apiServerUrl}/api/sample-collections/${sampleCollectionId}/submit/`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: JSON.stringify(formData),
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};

export const getDashboardSummary = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/dashboard/summary/`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};

// Pre-screen Manager API methods
export const getQuestionGroups = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/question-groups/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getQuestionGroup = async (token, groupName) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/question-groups/${groupName}/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const createQuestionGroup = async (token, groupData) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/question-groups/create/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: groupData,
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const cloneQuestionGroup = async (token, groupName, newName) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/question-groups/${groupName}/clone/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: { new_name: newName },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const deleteQuestionGroup = async (token, groupName) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/question-groups/${groupName}/delete/`,
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const setDefaultQuestionGroup = async (token, groupName) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/question-groups/${groupName}/set-default/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const setApprovalRequirement = async (token, groupName, requiresApproval) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/question-groups/${groupName}/set-approval/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      requires_approval: requiresApproval,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const updateQuestionGroup = async (token, groupName, updateData) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/question-groups/${groupName}/update/`,
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: updateData,
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getQuestions = async (token, groupName = null) => {
  const queryParams = groupName ? `?group=${encodeURIComponent(groupName)}` : '';
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/questions/${queryParams}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const createQuestion = async (token, questionData) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/questions/create/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: questionData,
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const updateQuestion = async (token, questionId, questionData) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/questions/${questionId}/update/`,
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: questionData,
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const cloneQuestion = async (token, questionId, questionData = null) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/questions/${questionId}/clone/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: questionData || {},
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const deleteQuestion = async (token, questionId) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/questions/${questionId}/delete/`,
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const reorderQuestions = async (token, questionGroup, questionOrders) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/questions/reorder/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      question_group: questionGroup,
      question_orders: questionOrders,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getQuestionFlow = async (token, groupName) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/flows/${groupName}/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const updateQuestionFlow = async (token, groupName, flowUpdates) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/flows/${groupName}/update/`,
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: { flow_updates: flowUpdates },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const validateQuestionFlow = async (token, groupName) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/flows/${groupName}/validate/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const dryRunQuestionGroup = async (token, groupName, answers) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen-manager/dry-run-question-group/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      question_group: groupName,
      answers,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

// Pending Approval API methods
export const getPendingApprovals = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/admin/pending-approvals/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const approveUser = async (token, userId) => {
  const config = {
    url: `${apiServerUrl}/api/admin/approve-user/${userId}/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getUserDetails = async (token, userId) => {
  const config = {
    url: `${apiServerUrl}/api/admin/users/${userId}/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

// Import/Export Functions
export const exportQuestionGroup = async (token, groupName) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/import-export/export/${groupName}/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const exportAllQuestionGroups = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/import-export/export/all/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const downloadQuestionTemplate = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/import-export/template/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const importQuestionGroups = async (token, file, overwrite = true) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('overwrite', overwrite.toString());

  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/import-export/import/`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: formData,
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getImportExportStatus = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/admin/prescreen/import-export/status/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

const formsAdminBase = `${apiServerUrl}/api/admin/forms`;

export const getFormQuestionGroups = async (token) => {
  const config = {
    url: `${formsAdminBase}/question-groups/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const getFormQuestionGroup = async (token, groupName) => {
  const config = {
    url: `${formsAdminBase}/question-groups/${encodeURIComponent(groupName)}/`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const createFormQuestionGroup = async (token, groupData) => {
  const config = {
    url: `${formsAdminBase}/question-groups/create/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: groupData,
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const cloneFormQuestionGroup = async (token, groupName, newName) => {
  const config = {
    url: `${formsAdminBase}/question-groups/${encodeURIComponent(groupName)}/clone/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: { new_name: newName },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const deleteFormQuestionGroup = async (token, groupName) => {
  const config = {
    url: `${formsAdminBase}/question-groups/${encodeURIComponent(groupName)}/delete/`,
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const updateFormQuestionGroup = async (token, groupName, groupData) => {
  const config = {
    url: `${formsAdminBase}/question-groups/${encodeURIComponent(groupName)}/update/`,
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: groupData,
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const getFormQuestions = async (token, groupName) => {
  const queryParams = groupName ? `?group=${encodeURIComponent(groupName)}` : '';
  const config = {
    url: `${formsAdminBase}/questions/${queryParams}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const createFormQuestion = async (token, questionData) => {
  const config = {
    url: `${formsAdminBase}/questions/create/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: questionData,
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const updateFormQuestion = async (token, questionId, questionData) => {
  const config = {
    url: `${formsAdminBase}/questions/${questionId}/update/`,
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: questionData,
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const cloneFormQuestion = async (token, questionId, cloneData) => {
  const config = {
    url: `${formsAdminBase}/questions/${questionId}/clone/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: cloneData,
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const deleteFormQuestion = async (token, questionId) => {
  const config = {
    url: `${formsAdminBase}/questions/${questionId}/delete/`,
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const reorderFormQuestions = async (token, groupName, questionOrders) => {
  const config = {
    url: `${formsAdminBase}/questions/reorder/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      question_group: groupName,
      group_name: groupName,
      question_orders: questionOrders,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const exportFormQuestionGroup = async (token, groupName) => {
  const config = {
    url: `${formsAdminBase}/import-export/export/${encodeURIComponent(groupName)}/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const downloadFormQuestionTemplate = async (token) => {
  const config = {
    url: `${formsAdminBase}/import-export/template/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const importFormQuestionGroups = async (token, file, overwrite = true) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('overwrite', overwrite.toString());
  const config = {
    url: `${formsAdminBase}/import-export/import/`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: formData,
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const dryRunFormQuestionGroup = async (token, groupName, answers) => {
  const config = {
    url: `${apiServerUrl}/api/admin/forms-manager/dry-run-question-group/`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      question_group: groupName,
      answers,
    },
  };
  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

// User Export Functions
export const exportUsersCSV = async (token, questionGroup, status = 'all') => {
  const config = {
    url: `${apiServerUrl}/api/admin/export-users-csv/?question_group=${encodeURIComponent(questionGroup)}&status=${encodeURIComponent(status)}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob', // Important for downloading files
  };

  try {
    const response = await fetch(config.url, {
      method: config.method,
      headers: config.headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Export failed: ${errorText}`);
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = `users_${questionGroup}_${status}_${new Date().toISOString().split('T')[0]}.csv`;
    
    if (contentDisposition) {
      const matches = contentDisposition.match(/filename="([^"]+)"/);
      if (matches) {
        filename = matches[1];
      }
    }

    // Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return {
      data: { success: true, filename },
      error: null,
    };
  } catch (error) {
    return {
      data: null,
      error: error.message,
    };
  }
};

export const bulkApproveUsersCSV = async (token, file, { dryRun = false } = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  if (dryRun) {
    formData.append('dry_run', 'true');
  }

  try {
    const response = await fetch(`${apiServerUrl}/api/admin/bulk-approve-users-csv/`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      return {
        data: null,
        error: data.error || data.detail || `Bulk approve failed (${response.status})`,
      };
    }
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message || 'Bulk approve failed' };
  }
};

// Member Records Services
export const getMemberRecords = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/records/my_records/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};

export const getMemberRecordAttachment = async (token, attachmentUrl) => {
  const config = {
    url: `${apiServerUrl}/api/records/my_records/attachment/`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ attachment_url: attachmentUrl }),
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};

// PDF download function removed - feature discontinued

export const getMemberProfileData = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/records/my_profile/`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};

export const updateMemberProfileData = async (token, data) => {
  const config = {
    url: `${apiServerUrl}/api/records/my_profile/update/`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  const { data: responseData, error } = await callExternalApi({ config });
  return {
    data: responseData || null,
    error,
  };
};

export const removeMemberProfileData = async (token, type, id) => {
  const config = {
    url: `${apiServerUrl}/api/records/my_profile/remove/`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ type, id }),
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};

export const requestEmailChange = async (token, newEmail) => {
  const config = {
    url: `${apiServerUrl}/api/me/change-email/`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ new_email: newEmail }),
  };

  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const verifyEmailChange = async (verifyToken) => {
  const config = {
    url: `${apiServerUrl}/api/me/verify-email/`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ token: verifyToken }),
  };

  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};

export const acceptOrgInvite = async (token) => {
  const config = {
    url: `${apiServerUrl}/api/org-admin/accept-org-invite/`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ token }),
  };

  const { data, error } = await callExternalApi({ config });
  return { data: data || null, error };
};
